//
export default [
    {
        field   : 'pch_provider_id',
        label   : 'Proveedor',
        options : [],
        value   : [],
        props   : {
            itemText    : 'business_name',
            itemValue   : 'id',
        }
    },
    {
        field   : 'of_warehouse',
        label   : 'Bodega',
        options : [],
        value   : [],
        props   : {
            itemText    : 'name',
            itemValue   : 'id',
        }
    },
    {
        field   : 'internal_code',
        label   : 'Código interno',
        value   : '',
    },
    {
        field   : 'wh_families_id',
        label   : 'Familias',
        options : [],
        value   : [],
        props   : {
            itemText    : 'family',
            itemValue   : 'id',
        }
    },
    {
        field   : 'wh_subfamilies_id',
        label   : 'Subfamilias',
        options : [],
        value   : [],
        props   : {
            itemText    : 'subfamily',
            itemValue   : 'id',
        }
    },
    {
        field   : 'tags',
        label   : 'Etiquetas',
        options : [],
        value   : [],
        props   : {
            itemText    : 'tag',
            itemValue   : 'id',
        }
    },
]